export default "__VITE_ASSET__6c5b1062__"